import React from 'react';
import {  FaTimes, FaExclamationTriangle, FaBolt,  FaUserPlus } from 'react-icons/fa';
import Loading from './Loading';

const ConfirmLogoutModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title = 'تأكيد تسجيل الخروج',
  message = 'هل أنت متأكد من أنك تريد تسجيل الخروج من حسابك؟',
  subMessage = 'سيتم إغلاق جلسة العمل الخاصة بك',
  confirmLabel = 'تسجيل الخروج',
  cancelLabel = 'إلغاء',
  variant = 'danger', // 'danger', 'success', 'warning', 'info'
  icon = null, // يمكن تمرير أيقونة مخصصة
}) => {
  if (!isOpen) return null;

  // تحديد الألوان والأيقونات حسب النوع
  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return {
          iconBg: 'bg-main1/25',
          iconColor: 'text-main1',
          buttonBg: 'bg-main1',
          buttonHover: 'hover:bg-opacity-90',
          defaultIcon: FaBolt
        };
      case 'warning':
        return {
          iconBg: 'bg-yellow-100',
          iconColor: 'text-yellow-600',
          buttonBg: 'bg-yellow-600',
          buttonHover: 'hover:bg-yellow-700',
          defaultIcon: FaExclamationTriangle
        };
      case 'info':
        return {
          iconBg: 'bg-blue-100',
          iconColor: 'text-blue-600',
          buttonBg: 'bg-blue-600',
          buttonHover: 'hover:bg-blue-700',
          defaultIcon: FaUserPlus
        };
      case 'danger':
      default:
        return {
          iconBg: 'bg-accent/25',
          iconColor: 'text-accent',
          buttonBg: 'bg-accent',
          buttonHover: 'hover:bg-opacity-90',
          defaultIcon: FaExclamationTriangle
        };
    }
  };

  const styles = getVariantStyles();
  const IconComponent = icon || styles.defaultIcon;

  return (
    <>
      {/* الخلفية المعتمة */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />
      
      {/* النافذة المنبثقة */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-light rounded-2xl shadow-xl max-w-md w-full mx-4 direction-rtl">
          {/* رأس النافذة */}
          <div className="flex items-center justify-between p-6 border-b border-grayish">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 ${styles.iconBg} rounded-full flex items-center justify-center`}>
                <IconComponent className={`${styles.iconColor} text-lg`} />
              </div>
              <h3 className="text-lg font-bold text-main1">{title}</h3>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              disabled={isLoading}
            >
              <FaTimes size={20} />
            </button>
          </div>
          
          {/* محتوى النافذة */}
          <div className="p-6">
            <p className="text-gray-700 mb-6 text-center">{message}</p>
            {subMessage && (
              <p className="text-sm text-gray-500 text-center mb-6">{subMessage}</p>
            )}
          </div>
          
          {/* أزرار الإجراءات */}
          <div className="flex gap-3 p-6 border-t border-grayish">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 px-4 py-2 text-main1 bg-grayish hover:bg-grayish/80 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={`flex-1 px-4 py-2 text-light ${styles.buttonBg} ${styles.buttonHover} rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2`}
            >
              {isLoading ? (
                <Loading type="spinner" size="sm" text="" color="main1" />
              ) : (
                <>
                  {/* <IconComponent /> */}
                  {confirmLabel}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmLogoutModal; 
